import React from 'react';
import Services from './../services/services';
import Breadcrumb from './../basics/Breadcrumb';
import Steps from './../basics/Steps';
import Moment from 'react-moment';
import ShopHeader from './../shop/ShopHeader';

import {
  BrowserRouter as Router, Route, Routes, Link
} from "react-router-dom";

import { useEffect, useState } from 'react';
import { useParams } from "react-router-dom";

const TermList = () => {

  let {id} = useParams();

  const [products, setProducts] = useState([]);

  const [selectedProduct, setSelectedProduct] = useState<any>("false");

  const [eventList, setEventList] = useState<any>([]);

  let newEventList: any[] = [];

  const productList: any[] = [];

  const services = new Services();

  useEffect(()=>{

    services.getFreeTerms().then((value: any) => {

      createList(value)

    });

    services.getProducts().then( (value: any) => {

      setProducts(value)

    });

  }, [])

  useEffect(()=>{

    services.getFreeTerms().then((value: any) => {

      const newEvents: any[] = [];

      value.map((val: any) => {

        if(val.product.name == selectedProduct) {

          newEvents.push(val);
        }

        if(selectedProduct == "false") {

          newEvents.push(val);
        }

      })

      createList(newEvents)

    });

  }, [selectedProduct])

  products.forEach((data: any) => {

    productList.push(<option value={data.name} >{data.name}</option>)

  })

  function createList( list: any ){

    newEventList = []

    console.log("test " + list);

    list.forEach((data: any, id: number, array: []) => {

      newEventList.push(
        <div className="row my-5">
          <div className="d-flex align-items-center flex-column col-2 border-end p-4">
            <Moment className="fw-bold" format="DD.MM.YYYY">
              {data.startDatetime}
            </Moment>
            <br />
            <Moment format="HH:mm">
              {data.startDatetime}
            </Moment>
          </div>
          <div className="d-flex align-items-center flex-column col-2 border-end p-4">
            {data.place.name}
          </div>
          <div className="d-flex align-items-center flex-column col-3 border-end p-4">
            {data.product.name}
            <br />
            <Link className="btn btn-sm rounded-pill btn-outline-primary mt-2" to={"/product-detail/"+data.product.id} >Koupit letenky</Link>
          </div>
          <div className="d-flex align-items-center flex-column col-2 border-end p-4">
            {data.balloon.name}
          </div>
          <div className="d-flex align-items-center flex-column col-1 border-end p-4">
            {data.capacity}
          </div>
          <div className="d-flex align-items-center flex-column col-2 p-4">
            <Link className="btn btn-lg rounded-pill btn-outline-primary mt-2" to={"/passenger-list/"+data.id} >Rezervovat</Link>
          </div>
        </div>
      )

      if (id !== array.length - 1){
         newEventList.push(<hr />)
     }

    })

    setEventList(newEventList)

  }

  const steps = [

    {'name':'Obchod', 'link':'/term-list', 'active': false},
    {'name':'Košík','link': '', 'active': true},
    {'name':'Pokladna','link': '', 'active': true},

  ];

  return (
    <div>

      <ShopHeader title="Termíny" subtitle="Termíny subtitle" image="https://balloonadventures.cz/wp-content/uploads/2019/07/IMG_0581.jpg"/>

      <div className="container py-5">

        <Steps links={steps} />

        <div className="col-10 mx-auto mb-4">

        <div className="fs-5 fw-bold text-primary">Zvolte typ termínu</div>
        <select className="form-select form-select-lg rounded-pill mb-5 form-control-bg border-0 mt-2" onChange={(e) => setSelectedProduct(e.target.value)}>
          <option value="false" selected>Všechny vypsané termíny</option>
          {productList}
        </select>

        </div>

        <div className="card border-0 custom-radius custom-shadow col-10 mx-auto">
          <div className="card-body">

            <div className="row text-primary fw-bold">
              <div className="d-flex align-items-center flex-column col-2 p-4">
                Termín
              </div>
              <div className="d-flex align-items-center flex-column col-2 p-4">
                Místo odletu
              </div>
              <div className="d-flex align-items-center flex-column col-3 p-4">
                Typ letu
              </div>
              <div className="d-flex align-items-center flex-column col-2 p-4">
                Balón
              </div>
              <div className="d-flex align-items-center flex-column col-1 p-4">
                Kapacita
              </div>
              <div className="d-flex align-items-center flex-column col-2 p-4">
                Status
              </div>
            </div>

          {eventList}

          </div>
        </div>
      </div>
    </div>
  );

}

export default TermList;
